import { Component, EventEmitter, Input, Output } from "@angular/core";
import { filterKeys } from "../../../constants/filters.constants";
import { IPanel } from "../../../util/common.models";

@Component({
  selector: "app-chips-list",
  templateUrl: "./chips-list.component.html",
  styleUrl: "./chips-list.component.scss",
})
export class ChipsListComponent {
  @Input() chips: { key: string; value: string; operation?: string }[] = [];
  @Input() editable: boolean = true;
  @Input() removable: boolean = false;
  @Input() addOnBlur: boolean = true;
  @Input() addOnTab: boolean = true;
  @Input() panels!: IPanel[];
  @Input() isPanel: boolean = false;

  @Output() chipsChange = new EventEmitter<any[]>();
  @Output() removedChip = new EventEmitter<any>();

  filterKeys = filterKeys;
  // Event to handle chip addition or removal
  onChipsChange(event: any) {
    this.chipsChange.emit(this.chips);
  }

  // Remove chip when "X" is clicked
  removeChip(chip: any) {
    this.chips = this.chips.filter((c) => c !== chip);
    this.chipsChange.emit(this.chips);
    this.removedChip.emit(chip);
  }

  getPanelLabels(value: string): string {
    if (!value) return "";

    return value
      .split("^$")
      .map((val) => {
        const match = this.panels?.find((panel) => panel?.value === val);
        return match ? match.label : val;
      })
      .join(", ");
  }

  getPanelLabel(value: string): string {    
    if (!value) return "";

    const panel = this.panels?.find((panel:any) => {
      if (panel?.value == value) {
        return panel;
      }
    })

    return panel ? panel.label : "";
  }
}
